import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicSharedRecording } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getSharedRecording = async (
  id: string,
): Promise<PublicSharedRecording> => {
  const response = await axiosClient.get(`shared-recordings/${id}`);
  return response.data;
};

export function useGetSharedRecording(
  { id }: { id: string },
  queryOptions?: UseQueryOptions<PublicSharedRecording, HttpError>,
) {
  return useQuery({
    queryKey: ["shared-recording", id],
    queryFn: () => getSharedRecording(id),
    ...queryOptions,
  });
}
